import FilterRadioButton from "@/components/Synonym/SynonymFilter/FilterRadioButton/FilterRadioButton.vue";
import { mapActions, mapGetters } from "vuex";

export default {
    name: "OrderOptions",
    components: {
        FilterRadioButton
    },
    data() {
        return {
            options: [
                { label: "sortingByVotes", value: "votes" },
                { label: "sortingByRelevance", value: "relevance" },
                { label: "sortingByAZ", value: "a-z" },
                { label: "sortingByZA", value: "z-a" }
            ],
            currentValue: "votes"
        };
    },
    computed: {
        ...mapGetters("Login", ["user"])
    },
    methods: {
        ...mapActions("ThesaurusFilter", ["orderThesaurusBy"]),
        onFilterRadioChanged(value) {
            this.currentValue = value;
            this.orderThesaurusBy(value);
            this.$ga.event({
                eventCategory: "Sorting by",
                eventAction: value
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Synonym/SynonymFilter/OrderOptions/OrderOptions.js